import moment, { MomentInput } from 'moment'

export const daysFromToday = (date: MomentInput): number =>
  moment(date).startOf('day').diff(moment().startOf('day'), 'days')

/**
 * Asana-style label: Today, Tomorrow, the weekday for the rest of the week, else 'MMM D'.
 * `withYear` adds the year to that last form, for dates that can sit years out.
 */
export const formatRelativeDueDate = (
  date: MomentInput,
  { withYear = false }: { withYear?: boolean } = {},
): string => {
  const days = daysFromToday(date)
  if (days === 0) return 'Today'
  if (days === 1) return 'Tomorrow'
  if (days >= 2 && days <= 6) return moment(date).format('dddd')
  return moment(date).format(withYear ? 'MMM D, YYYY' : 'MMM D')
}

/** Overdue reads red, today and tomorrow green, anything later plain. */
export const relativeDueDateTone = (date: MomentInput): 'overdue' | 'soon' | null => {
  const days = daysFromToday(date)
  if (days < 0) return 'overdue'
  return days <= 1 ? 'soon' : null
}
